/* MQA 3.0 — frame finish-family filter.
   Additive & engine-safe: reads each frame swatch's name, tags data-family, and renders a
   chip row that shows/hides swatches. It NEVER touches the radio inputs, their values, the
   frame preview, or the mqa_sync line-item contract — selection state is untouched.
   Rules: colors multi-tag (a Black+Gold frame appears under both Black and Gold);
   Wood = natural tones only (a frame naming any metal/color is excluded from Wood).
   Hidden entirely for Ready-to-Hang (stretched) canvas — its floats show directly (per spec). */
(function () {
  'use strict';

  var COLOR = { gold: ['gold'], silver: ['silver'], bronze: ['bronze'], black: ['black'], white: ['white', 'cottage', 'ivory'] };
  var NATURAL = ['espresso', 'oak', 'walnut', 'natural', 'maple', 'driftwood', 'teak'];
  // Manual family adds for frames that lean a finish their title doesn't name
  // (e.g. a warm "silver" that actually reads bronze). Key = lowercased frame title.
  var FORCE = { 'ornate silver frame': ['bronze'] };
  var LABEL = { all: 'All Frames', gold: 'Gold', silver: 'Silver', bronze: 'Bronze', black: 'Black', white: 'White', wood: 'Natural' };
  var ORDER = ['all', 'gold', 'silver', 'bronze', 'black', 'white', 'wood'];

  function famsFor(name) {
    var low = String(name).toLowerCase().trim(), out = [];
    Object.keys(COLOR).forEach(function (f) {
      if (COLOR[f].some(function (k) { return low.indexOf(k) > -1; })) out.push(f);
    });
    if (!out.length && NATURAL.some(function (k) { return low.indexOf(k) > -1; })) out.push('wood');
    (FORCE[low] || []).forEach(function (f) { if (out.indexOf(f) < 0) out.push(f); });
    return out;
  }

  function init(opt) {
    if (!opt || opt.__mqaFam) return;
    var fieldset = opt.querySelector('.product-option-swatches');
    if (!fieldset) return;
    var swatches = [].slice.call(fieldset.querySelectorAll('.product-option-swatch'));
    if (!swatches.length) return;
    opt.__mqaFam = true;

    var present = {};
    swatches.forEach(function (sw) {
      var input = sw.querySelector('input');
      var name = (input && input.value) || sw.getAttribute('title') || '';
      if (/art only/i.test(name)) { sw.setAttribute('data-mqa-artonly', '1'); return; }
      var fams = famsFor(name);
      sw.setAttribute('data-family', fams.join(' '));
      fams.forEach(function (f) { present[f] = true; });
    });

    var bar = document.createElement('div');
    bar.className = 'mqa-frame-families';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Filter frames by finish');
    ORDER.forEach(function (f) {
      if (f !== 'all' && !present[f]) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mqa-fam-chip' + (f === 'all' ? ' is-active' : '');
      b.setAttribute('data-fam', f);
      b.setAttribute('aria-pressed', f === 'all' ? 'true' : 'false');
      b.textContent = LABEL[f];
      bar.appendChild(b);
    });
    var anchor = opt.querySelector('.custom-show-all') || fieldset;
    anchor.parentNode.insertBefore(bar, anchor);

    // The engine always marks the show-all ".loaded" (toggle always shows) and measures the FULL
    // set once. After a family filter hides frames, re-check whether the VISIBLE frames still fit
    // within the preview rows; if they do, flag .mqa-showall-fits so CSS hides the toggle+divider.
    function refreshShowAll() {
      var sa = opt.querySelector('.custom-show-all');
      if (!sa) return;
      var vis = fieldset.querySelectorAll('.product-option-swatch:not(.mqa-fam-hidden):not(.hidden)');
      if (!vis.length) { sa.classList.remove('mqa-showall-fits'); return; }
      var rows = parseInt(sa.getAttribute('data-preview-rows'), 10) || 2;
      var limit = (vis[0].getBoundingClientRect().height + 8) * rows + 4;
      sa.classList.toggle('mqa-showall-fits', fieldset.getBoundingClientRect().height <= limit);
    }

    function apply(fam) {
      fam = fam || 'all';
      swatches.forEach(function (sw) {
        if (sw.getAttribute('data-mqa-artonly')) return; // Art Only always visible
        var f = ' ' + (sw.getAttribute('data-family') || '') + ' ';
        var show = fam === 'all' || f.indexOf(' ' + fam + ' ') > -1;
        sw.classList.toggle('mqa-fam-hidden', !show);
      });
      [].forEach.call(bar.children, function (c) {
        var on = c.getAttribute('data-fam') === fam;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      (window.requestAnimationFrame || setTimeout)(refreshShowAll, 0);
    }

    function activeChip() {
      var a = bar.querySelector('.is-active');
      return a ? a.getAttribute('data-fam') : 'all';
    }

    bar.addEventListener('click', function (e) {
      var chip = e.target && e.target.closest ? e.target.closest('.mqa-fam-chip') : null;
      if (chip) apply(chip.getAttribute('data-fam'));
    });

    // Ready-to-Hang (stretched) canvas → floats only; hide the family filter (spec).
    // Detected semantically via the selected material's Style-variant name (rename-proof).
    function context() {
      var mat = document.querySelector('input[name="properties[Material]"]:checked');
      var framed = mat ? (mat.getAttribute('data-product-option-framed') || '') : '';
      var stretched = framed === 'Framed Canvas';
      bar.style.display = stretched ? 'none' : '';
      opt.classList.toggle('mqa-floats-only', stretched); // state hook: float frames fit one row
      apply(stretched ? 'all' : activeChip());
    }

    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'properties[Material]') setTimeout(context, 60);
    });
    context();
    [150, 450, 1000].forEach(function (t) { setTimeout(refreshShowAll, t); }); // catch engine's async show-all setup

    // Compact trust + info row on the "About this print" line:
    //   ⓘ About this print · ♥ Promise · 📦 Free shipping — each expands its copy on click.
    // Promise/shipping copy is pulled from the (CSS-hidden) callout block so it stays editable in the
    // theme editor. Read-only: never touches radios/values/preview/mqa_sync. 'info' reuses the
    // engine-managed .detail-card (its content already follows the selected frame).
    var card = opt.querySelector('.detail-card');
    if (card && !card.__mqaInfo) {
      card.__mqaInfo = true;

      var ct = document.querySelectorAll('[data-section-type="product"] .product__block-callouts .product__callouts-item-text');
      var promiseHtml = ct[0] ? ct[0].innerHTML : '';
      var shipHtml = ct[1] ? ct[1].innerHTML : '';

      var ICON = {
        info: '<span class="mqa-info-i" aria-hidden="true">i</span>',
        promise: '<svg class="mqa-trust-ic" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
        ship: '<svg class="mqa-trust-ic" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><path d="M3 7l9-4 9 4-9 4-9-4z"/><path d="M3 7v10l9 4 9-4V7"/><path d="M12 11v10"/></svg>'
      };

      var row = document.createElement('div');
      row.className = 'mqa-trust-row';
      var detail = document.createElement('div');
      detail.className = 'mqa-trust-detail';
      detail.hidden = true;

      var infoBtn = null;
      function addItem(key, label) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mqa-trust-item';
        b.setAttribute('data-mqa-trust', key);
        b.setAttribute('aria-expanded', 'false');
        b.innerHTML = ICON[key] + '<span class="mqa-trust-label">' + label + '</span>';
        row.appendChild(b);
        return b;
      }
      infoBtn = addItem('info', 'About This Print');
      if (promiseHtml) addItem('promise', 'Museum Quality Promise');
      if (shipHtml) addItem('ship', 'Free Shipping on $200+');

      card.parentNode.insertBefore(row, card);
      if (card.nextSibling) card.parentNode.insertBefore(detail, card.nextSibling);
      else card.parentNode.appendChild(detail);

      var current = null;
      function setActive(key) {
        var off = current === key;
        current = off ? null : key;
        [].forEach.call(row.children, function (c) {
          var on = !off && c.getAttribute('data-mqa-trust') === key;
          c.classList.toggle('is-open', on);
          c.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
        card.classList.toggle('mqa-open', !off && key === 'info');
        if (!off && (key === 'promise' || key === 'ship')) {
          detail.innerHTML = key === 'promise' ? promiseHtml : shipHtml;
          detail.hidden = false;
        } else {
          detail.hidden = true;
        }
      }
      row.addEventListener('click', function (e) {
        var it = e.target && e.target.closest ? e.target.closest('.mqa-trust-item') : null;
        if (it) setActive(it.getAttribute('data-mqa-trust'));
      });

      // Set the info-item label now; the module-level syncInfoLabels() keeps it correct even when
      // the frame is set programmatically (landing on a framed variant) — see boot()/change listener.
      syncInfoLabels();
    }
  }

  // Keep the info-item label correct even when the frame is set PROGRAMMATICALLY — landing on a
  // framed variant selects the frame with no 'change' event, so we re-sync on boot/retries + changes.
  function syncInfoLabels() {
    var fr = document.querySelector('input[name="properties[Frame]"]:checked');
    var artOnly = fr && /art only/i.test(fr.value || '');
    var labels = document.querySelectorAll('.mqa-trust-item[data-mqa-trust="info"] .mqa-trust-label');
    [].forEach.call(labels, function (lbl) {
      lbl.textContent = artOnly ? 'About This Print' : 'About This Frame';
    });
  }

  // The Wishlist King app owns its button text, so relabel "Add to Wishlist" → "Save for later"
  // client-side and observe for the app's add/added re-render. (Cleaner long-term: set it in the app.)
  function wishText(s) {
    return s.replace(/Added to Wishlist/gi, 'Saved for later').replace(/Add to Wishlist/gi, 'Save for later');
  }
  function relabelWishlist() {
    [].forEach.call(document.querySelectorAll('.wk-button'), function (btn) {
      var al = btn.getAttribute('aria-label');
      if (al) { var na = wishText(al); if (na !== al) btn.setAttribute('aria-label', na); }
      if (window.NodeFilter) {
        var w = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null), n;
        while ((n = w.nextNode())) { var nt = wishText(n.nodeValue); if (nt !== n.nodeValue) n.nodeValue = nt; }
      }
      if (!btn.__mqaWish && window.MutationObserver) {
        btn.__mqaWish = new MutationObserver(function () { relabelWishlist(); });
        btn.__mqaWish.observe(btn, { childList: true, subtree: true, characterData: true });
      }
    });
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('.product-option[data-type="frames"]'), init);
    syncInfoLabels();
    relabelWishlist();
  }

  document.addEventListener('change', function (e) {
    var n = e.target && e.target.name;
    if (n === 'properties[Frame]' || n === 'properties[Material]' || (n && n.indexOf('options[') === 0)) {
      setTimeout(syncInfoLabels, 60);
    }
  });

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  // Retries in case the buy box / frame option is injected — and to catch programmatic frame selection.
  [200, 400, 700, 1200, 1800].forEach(function (ms) { setTimeout(boot, ms); });
})();
